module.exports = __webpack_public_path__ + "static/media/logo.62906656.gif";